import { apiCallJson, apiCallExportFile, apiCallFile } from "../Helpers";

export async function getLanguages(querySets) {
  const query = new URLSearchParams();

  querySets.forEach((element) => {
    query.set(element.key, element.value);
  });

  return await apiCallJson("/Language?translated=true", "GET", null);
}

export async function getLanguageByCode(
  languageCode,
  pageNumber,
  recordsPerPage,
  propSort,
  descending,
  filter
) {
  let filterQuery = "";
  if (filter) {
    filter.forEach((element) => {
      if (element.value) {
        filterQuery += "&" + element.key + "=" + element.value;
      }
    });
  }

  let sortQuery = "";
  if (propSort) {
    sortQuery = "&sortProp=" + propSort + "&descending=" + descending;
  }
  return await apiCallJson(
    "/Language/Translations/" +
      languageCode +
      "/all?pageNumber=" +
      pageNumber +
      "&recordsPerPage=" +
      recordsPerPage +
      sortQuery +
      filterQuery,
    "GET",
    null
  );
}

export async function addLanguageTranslationByCode(languageCode, key, value) {
  return await apiCallJson("/Language/Translations/" + languageCode, "POST", [
    {
      key: key,
      value: value,
    },
  ]);
}

export async function getLanguageCountByCode(languageCode) {
  return await apiCallJson(
    "/Language/translations/count/" + languageCode,
    "GET",
    null
  );
}

export async function updateLanguageByCode(languageCode, key, value) {
  return await apiCallJson("/Language/Translations/" + languageCode, "PUT", [
    { key: key, value: value },
  ]);
}

export async function deleteLanguageTranslationByCode(languageCode, key) {
  return await apiCallJson("/Language/Translations/" + languageCode, "DELETE", [
    {
      key: key,
    },
  ]);
}

export async function exportLanguageCsv(languageCode, filename) {
  return await apiCallExportFile(
    "/Language/" + languageCode + "/export/file",
    "GET",
    null,
    filename
  );
}

export async function ImportFileLanguageAsync(languageCode, file) {
  return await apiCallFile(
    "/Language/" + languageCode + "/import/file",
    "POST",
    file
  );
}

export async function getAllTranslationsParams(culture) {
  return await apiCallJson(`/Language/translations/${culture}`, "GET");
}
